// extracted by mini-css-extract-plugin
module.exports = {"customChatbotStyling":"MileagePage_customChatbotStyling__TbTla","shimmer":"MileagePage_shimmer__ubwqL"};